import Technology from "../catalog/Catalog";

const PhonesPage = () => {
  const headline = 'Phones';
  const title = 'Mobile Phones';

  return (
    <Technology headline={headline} title={title} />  
  );
};

export default PhonesPage;
